
const state = {
  selectedView: 'CustomCards',
  factTable: 'dw_ytd_comparative',
  dateRange: ''
}

const getters = {
}

const mutations = {
  commit_selected_view (state, id) {
    state.selectedView = id
  },
  commit_factTable (state, str) {
    state.factTable = str
  },
  commit_dateRange (state, str) {
    state.dateRange = str
  },
  commit_initCleanStates (state) {
    state.selectedView = 'CustomCards'
  }
}

const actions = {

}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/dashCustomCards.js